export enum PropertyCategory {
    VENDA = 1,
    LOCACAO = 2,
    AMBOS = 3
}

export const getPropertyCategoryDescription = (value: number | undefined): string => {
    switch (value) {
        case PropertyCategory.VENDA:
            return 'Venda';
        case PropertyCategory.LOCACAO:
            return 'Locação';
        case PropertyCategory.AMBOS:
            return 'Venda e Locação';
        default:
            return '';
    }
};
